import React from 'react';
import { Dialog } from '../dialog/dialog';
import { useMimic } from '../../hooks/useMimic';
import styles from './power-bi-delete-confirm-dialog.module.scss';

interface PowerBiDeleteConfirmDialogProps {
  viewName: string;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function PowerBiDeleteConfirmDialog({
  viewName,
  isDeleting,
  onClose,
  onConfirm,
}: PowerBiDeleteConfirmDialogProps) {
  const { isMimic, mimicUser } = useMimic();

  return (
    <Dialog
      title="Delete View"
      onClose={onClose}
      width={400}
      actions={[
        { label: 'Cancel', onClick: onClose, variant: 'cancel' },
        {
          label: 'Delete',
          onClick: onConfirm,
          loading: isDeleting,
          variant: 'danger',
        },
      ]}
    >
      {isMimic && mimicUser && (
        <p className={styles['mimic-notice']} role="status">
          You are managing Saved Views for {mimicUser.name} while operating in
          Mimic Mode.
        </p>
      )}
      <p className={styles['body']}>
        Are you sure you want to delete{' '}
        <strong>&ldquo;{viewName}&rdquo;</strong>? This action cannot be undone.
      </p>
    </Dialog>
  );
}
